import { render, staticRenderFns } from "./QuestionOne.vue?vue&type=template&id=7fa0221b&scoped=true&"
import script from "./QuestionOne.vue?vue&type=script&lang=js&"
export * from "./QuestionOne.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOne.vue?vue&type=style&index=0&id=7fa0221b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa0221b",
  null
  
)

export default component.exports